<template>
    <footer class="footer">
        <div class="footer-info columns">
            <div class="footer-column">
                <h2>Beratung & Service</h2>
                <p>Erreichbar Mo - Fr zwischen 8 Uhr & 17 Uhr</p>
                <p>Ausstellungsbesuche ausschließlich nach Terminvereinbarung</p>
                </div>
            <div class="footer-column">
                <h2>Kontakt</h2>
                <p>Tel 02166 - 606220</p>    
                <p>Fax 02166 - 606226</p>    
                <p>info[at]marmor-kunze.de</p>    
            </div>
            <div class="footer-column">
                <h2>Anschrift</h2>
                <p>Marie-Bernays-Ring 17b</p>    
                <p>41199 Mönchengladbach</p>   
            </div>
            
        </div>
        <div class="email-info">
                E-Mails bitte nur mit informativ ausgefüllter Betreffzeile, da sonst zum Schutz diese ggf. gelöscht werden!
            </div>
         <div class="google-map" id="map"></div>
        <div class="footer-nav">
            <router-link class="footer-nav-item" :to="{ name: 'Impressum' }">Impressum</router-link>
            <router-link class="footer-nav-item" :to="{ name: 'Datenschutz' }">Datenschutz</router-link>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'Footer',
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/interface/Footer/Footer.vue